function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.872 2.974C3.872 1.884 4.756 1 5.846 1h4.308c1.09 0 1.974.884 1.974 1.974v.972a1.975 1.975 0 011.436 1.9v.972A1.975 1.975 0 0115 8.718v4.308c0 1.09-.884 1.974-1.974 1.974H2.974A1.974 1.974 0 011 13.026V8.718c0-.904.607-1.666 1.436-1.9v-.972c0-.904.607-1.665 1.436-1.9v-.972zm1.077.898h6.102v-.898a.897.897 0 00-.897-.897H5.846a.897.897 0 00-.897.897v.898zM3.513 6.744h8.974v-.898a.897.897 0 00-.897-.897H4.41a.897.897 0 00-.897.897v.898zM2.974 7.82a.897.897 0 00-.897.897v4.308c0 .495.402.897.897.897h10.052a.897.897 0 00.897-.897V8.718a.897.897 0 00-.897-.897H2.974z",
  fill: "#2D2D2D"
});
function SvgProcesosmasivos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Procesos masivos.svg";
export { SvgProcesosmasivos as ReactComponent };